import {
  checkCompatibility,
  type CompatibilityResult,
} from '@streamlain/field-types';

import type { ContentDbColumn } from '../utils/get-content-db-columns';

const COMPAT_ORDER: Record<CompatibilityResult, number> = {
  compatible: 0,
  castable: 1,
  incompatible: 2,
};

export function bestCompatibility(
  columnType: string,
  accepted: ReadonlyArray<string>
): CompatibilityResult {
  let best: CompatibilityResult = 'incompatible';
  for (const t of accepted) {
    const r = checkCompatibility(t, columnType);
    if (COMPAT_ORDER[r] < COMPAT_ORDER[best]) best = r;
    if (best === 'compatible') return best;
  }
  return best;
}

export interface PartitionedColumns {
  compatible: ContentDbColumn[];
  castable: ContentDbColumn[];
  incompatible: ContentDbColumn[];
}

export function partitionByCompatibility(
  columns: ReadonlyArray<ContentDbColumn>,
  accepted?: ReadonlyArray<string>
): PartitionedColumns {
  const result: PartitionedColumns = {
    compatible: [],
    castable: [],
    incompatible: [],
  };
  if (!accepted || accepted.length === 0) {
    result.compatible = [...columns];
    return result;
  }
  for (const col of columns) {
    result[bestCompatibility(col.type, accepted)].push(col);
  }
  return result;
}
